import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-arrow-down-rounded",
  "use": "ico-arrow-down-rounded-usage",
  "viewBox": "0 0 18.533 10.477",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.533 10.477\" id=\"ico-arrow-down-rounded\">\n  <path id=\"ico-arrow-down-rounded_Path_1535\" data-name=\"Path 1535\" d=\"M13.7,11l7.488,7L28.7,11\" transform=\"translate(-11.938 -9.233)\" fill=\"none\" stroke=\"#002420\" stroke-linecap=\"round\" stroke-width=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol